module.exports = __webpack_public_path__ + "static/media/unlock-chest-image.a74f7363.png";